import {
  BONUS_FETCH_REQUEST,
  SHOW_BONUS_MODAL,
  HIDE_BONUS_MODAL,
  BONUS_TAKE_REQUEST,
  SHOW_BONUS_ERROR,
} from "../constants";

export const fetchBonus = () => ({
  type: BONUS_FETCH_REQUEST,
  payload: {},
});

export const takeBonus = () => ({
  type: BONUS_TAKE_REQUEST,
  payload: {},
});

export const showBonusModal = () => ({
  type: SHOW_BONUS_MODAL,
  payload: {},
});

export const hideBonusModal = () => ({
  type: HIDE_BONUS_MODAL,
  payload: {},
});

export const showBonusError = () => ({
  type: SHOW_BONUS_ERROR,
  payload: {},
});
